// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"19351":"a5ce6a92","46832":"c42ece5b"}[chunkId] || chunkId) + "." + {"11389":"3342d57433acc373","19351":"c1f7de0082641d15","46832":"5a2abdfd83fc2dcd","53348":"5c850635ce5abf56","77157":"f65fecc57e31874e","82591":"c75b5ee2e2302348"}[chunkId] + ".js";
};